/**
 * 新闻数据模拟
 * 后期将从后端接口获取
 */

/**
 * 判断新闻是否可以展示
 * 无 publishAt 字段的新闻始终可见；有 publishAt 的新闻需到达发布时间后才可见
 */
export const isNewsVisible = (item) => {
  if (!item.publishAt) return true;
  return new Date() >= new Date(item.publishAt);
};

export const newsDatas = {
  zh: [
    {
      id: 1,
      category: 'fertility',
      date: '2025-11-20',
      image: '/image/641.webp',
      title: `梁建章5亿港元设"创生基金" 资助三大方向鼓励生育`,
      description: `11月20日世界儿童日，携程集团联合创始人梁建章宣布以个人名义，在香港设立"创生基金会"（Genovation Foundation Limited），计划五年内投入5亿港元，通过"经济补贴、文化倡导、政策研究"三大方向，系统性探索低生育率问题解决方案。据了解，除将支持于2026年1月启动，计划每年度举办的"全球生育危机论坛"进行政策研究，基金还已开放两大方向资助的申报：面向香港地区在读博士生的生育津贴、面向全球的"生育友好"主题文化艺术创意项目资助。`,
      content: `11月20日世界儿童日，携程集团联合创始人梁建章宣布以个人名义，在香港设立"创生基金会"（Genovation Foundation Limited），计划五年内投入5亿港元，通过 **"经济补贴、文化倡导、政策研究"** 三大方向，系统性探索低生育率问题解决方案。基金会名称"Genovation"融合"基因"（Gene）与"创新"（Innovation），既寓意生命传承的本质，更彰显用创新思维破解社会难题的初心--这是梁建章十余年深耕人口议题后，从企业实践走向社会公益的又一重磅行动。

<video controls width="100%" style="margin: 20px 0;">
  <source src="/video/20251120-205743.mp4" type="video/mp4">
  您的浏览器不支持视频播放。
</video>
<p style="text-align: center; font-size: small; color: gray;">直击低生育难题！我将以个人名义设5亿港元 “创生基金” 基金将从经济补贴、文化倡导、政策研究三大方向发力，探索低⽣育率问题...</p>

据了解，除将支持于2026年1月启动，计划每年度举办的"全球生育危机论坛"进行政策研究，基金还已开放两大方向资助的申报：面向香港地区在读博士生的生育津贴、面向全球的"生育友好"主题文化艺术创意项目资助。

作为长期关注人口与创新力关系的学者型企业家，梁建章认为： “孩子是最好的‘新基建’”。他在多部著作中预警：**年轻人口萎缩将直接削弱国家创新活力与长期经济增长动力，而破解这一困境需要政府、企业与社会形成合力。** 此次 “创生基金” 以 “**一个地区试点、三大方向发力**” 为核心，正是他将学术研究、企业实践转化为可复制社会样本的一次重要探索。

![创生基金](/image/641.webp)


#### **在香港地区试点 向在读博士生发放5万港币生育津贴**

首阶段基金将在香港率先试点，针对高校在读博士生推出专项生育津贴。博士生作为科研创新的后备中坚，正处于学业攻坚、职业起步与家庭规划的关键交叉期 —— 虽处生理生育黄金期，却常因科研压力大、收入有限、育儿成本高，被迫推迟甚至放弃生育计划。

对此，基金推出定向解决方案：2026 年 1 月 1 日（含）后生育子女的香港全日制在读博士生家庭，可申请 5 万港元育儿与教育津贴，有效缓解经济负担。申请流程简洁高效：申请人仅需提交子女出生证明、高校在读证明及成绩单，基金将在 14 个工作日内完成审核，5 个工作日内拨款。（详情请点击页面左下方“阅读原文”，或查询创生基金官网：https://www.genovationfoundation.org/）

#### **支持“生育友好”主题文化艺术创意项目 单项至高100万元港币**

梁建章深知，低生育率背后是经济成本、社会观念、生育焦虑等多重因素交织，破解难题既需物质支持，更需文化氛围塑造。为此，基金设立 “生育友好” 文化艺术创意专项，面向全球征集能激发生育意愿、传递家庭温暖、破除生育焦虑的作品与项目。

该专项资助至高奖金100 万港元，每年评选一次，鼓励通过各类艺术形式、文旅活动、创意方案等，让生育成为更具幸福感、安全感的选择。

#### **支持国际学界研究人口政策 创办“全球生育危机论坛”**

低生育率是全球共同挑战，需要跨国家、跨学界的经验共享。基金将重点支持国际人口政策研究，核心举措之一便是于 2026 年 1 月在香港举办首届 “全球生育危机论坛”。 
（详情可查询全球生育危机论坛官网：https://globalfertilitycrisis.org/）

论坛将围绕全球人口形势、低生育率经济影响、各国政策实践、女性生育与职业发展平衡等关键议题，兼顾宏观分析与个体故事分享，计划常态化举办，打造长期稳定的国际交流平台。梁建章认为，科学政策与足够支持力度能有效提振生育意愿，而论坛正是为了汇集全球智慧，为政策制定提供参考。

#### **十余年深耕不辍 从企业实践到社会公益的持续坚守**

设立 “创生基金”，是梁建章在生育支持领域的又一次自我突破。过去十余年，他不仅著书立说《人口创新力》《创新主义》等，更在携程率先落地一系列生育友好实践：除全球员工均可获得生育补贴外，还推出 3 天额外育儿假期。同时，他也致力于用大众喜闻乐见的方式，搭建生育友好的社会共识：如此前主创生命哲学寓言小说和戏剧《永生之后》、推出多孩家庭访谈节目《梁建章对话多孩 “生” 活》等。

他多次呼吁国家加大育儿补贴力度，提出个税减免、多孩家庭房贷利息返还、发展普惠托育等系统性建议。当前，国家育儿补贴政策已正式落地，社会对低生育率危机的认知日益加深，此次以个人名义投入 5 亿港元，正是他 “以企业实践探路、以社会公益扩容” 理念的延伸 —— 从关注企业员工到覆盖社会群体，从聚焦经济补贴到构建 “经济 + 文化 + 政策” 三重支持体系，梁建章表示，守护生育意愿，就是守护社会的未来与创新的根基。希望 “创生基金” 能成为一粒种子，带动更多社会力量参与，让生育不再是年轻人的 “两难选择”，而是充满希望的 “幸福抉择”。

#### **关于创生基金会**

**创生基金会**是一家专注于人口发展与社会创新的公益慈善基金。基金名称 “Genovation” 融合 “基因”（Gene）与 “创新”（Innovation），既寓意生命传承的本质，更彰显用创新思维破解社会难题的初心 。基金会由梁建章博士以个人名义在香港设立，计划五年投入5亿港元，致力于扶贫兴教、促进生育、倡导家善。

[来源链接](https://view.inews.qq.com/a/20251120A01XTD00?no-redirect=1)
`,
    },
    {
      id: 2,
      category: 'fertility',
      date: '2026-02-12',
      image: '/image/20260212-110032.jpg',
      title: '全球生育危机论坛',
      description:
        '首届“全球生育危机论坛”于2026年1月22-23日在中国香港举办，旨在探讨应对低生育率挑战的可行路径，该论坛汇聚了联合国及十多个国家的四十余位专家学者、政策制定者与企业代表。主旨演讲环节聚焦于全球低生育率趋势及其影响。三个报告环节则分别介绍不同地区生育趋势、政府应对措施以及构建生育支持体系的问题。而四个座谈环节围绕生育支持体系、职场友好、女性困境、教育焦虑等展开。梅耶·马斯克在与梁建章的对话中，分享育儿经历，以及倡导“放手式”育儿的理念，她建议女性尽早生育。',
      content: `首届“全球生育危机论坛”于2026年1月22-23日在中国香港举办，旨在探讨应对低生育率挑战的可行路径，该论坛汇聚了联合国及十多个国家的四十余位专家学者、政策制定者与企业代表。

主旨演讲环节聚焦于全球低生育率趋势及其影响。三个报告环节则分别介绍不同地区生育趋势、政府应对措施以及构建生育支持体系的问题。而四个座谈环节围绕生育支持体系、职场友好、女性困境、教育焦虑等展开。梅耶·马斯克在与梁建章的对话中，分享育儿经历，以及倡导“放手式”育儿的理念，她建议女性尽早生育。

首日的公开研讨结束是发布的《应对全球生育危机倡议》指出，低生育率是关乎文明兴衰的重大危机，呼吁全球各界凝聚共识、强化支持、推动协作，还提出五大具体行动倡议。论坛次日的闭门会议则探讨了如何建立合作机制，共同应对全球生育危机的方案。

![创生基金](/image/20260212-110032.jpg)
`,
    },
    {
      id: 4,
      category: 'fertility',
      date: '2026-08-05',
      publishAt: '2026-08-05T10:00:00+08:00',
      image: '/image/16-9.jpg',
      title: '推动职场生态升级 2026家庭友好企业评选启动',
      description: `8月5日，由创生基金联合 LinkedIn（领英）中国、雇主品牌研究所共同发起的"2026家庭友好企业评选"正式启动。本次评选面向符合条件的企业开放公益申报，将通过建立科学、系统、具实践指导意义的评价体系，推动家庭友好从零散福利措施走向制度化建设，进一步凝聚企业、员工与社会的价值共识。`,
      content: `8月5日，由创生基金联合 LinkedIn（领英）中国、雇主品牌研究所共同发起的"2026家庭友好企业评选"正式启动。本次评选面向符合条件的企业开放公益申报，将通过建立科学、系统、具实践指导意义的评价体系，推动家庭友好从零散福利措施走向制度化建设，进一步凝聚企业、员工与社会的价值共识。

## 顺应人才发展趋势，让家庭友好成为行业共识

当前，人口结构、家庭形态与就业方式正发生深刻变化，减少工作与家庭的现实冲突，已成为影响员工留存、人才竞争力和组织可持续发展的关键课题。近年来，部分企业已围绕弹性工作、生育支持、子女照护、员工健康等方面积极探索，但整体来看，相关实践仍存在制度分散、标准不一、落地效果难评估等问题，行业也缺少可对比、可指导的评价标准，优秀经验难以沉淀与推广。在此背景下，创生基金发起本次评选，希望通过标准引领、专业评估和案例推广，为企业提供可对照、可诊断、可改进的行动框架，推动家庭友好型职场建设从零散探索走向系统实践。

创生基金由携程集团董事局主席、人口经济学家梁建章博士于2025年11月以个人名义在香港设立，计划五年内投入5亿港元，从经济补贴、政策研究支持及文化倡导三个方向，探索应对低生育率的路径，推动生育友好型社会建设。本次评选是该基金在家庭友好职场领域的一项具体举措。

![2026家庭友好企业评选宣传图](/image/16-9.jpg)

## 搭建评价体系，助力家庭友好落地

2026家庭友好企业评选，参考联合国儿童基金会家庭友好政策框架及国内外相关研究成果，结合企业管理实践，构建以员工家庭友好支持和企业外部社会贡献为主要内容的评价体系。

在企业内部，评价体系重点关注时间灵活、资金资源、服务照护和职业文化四个维度，综合考察企业是否能够通过更加灵活的工作安排缓解员工的时间压力，是否提供具有实际支持作用的家庭保障，是否建立覆盖托育、健康及心理关怀等需求的服务机制，以及是否形成平等、包容、尊重家庭责任的职场文化。

对于面向个人及家庭用户的企业，评选还将关注其是否将家庭友好理念延伸至产品设计、服务流程和公益行动之中，推动企业由服务内部员工进一步走向服务家庭、回馈社会。

评选将按照企业报名、问卷填报、材料抽样核验和综合评审等程序有序推进。评审委员会由人口发展、劳动经济、社会政策、人力资源管理及企业实践等领域的专家组成，依据统一标准开展独立评审，确保评选过程规范、客观，评选结果专业、可信。

![评选顾问及专家评审团](/image/20260805-poster.jpg)

<p style="text-align: center; font-size: small; color: gray;">顾问及专家评审团</p>

评选坚持公益属性，不收取任何费用，所有参评企业均可获得专属评估反馈。反馈报告将梳理企业在家庭友好建设中的优势与不足，并提供行业对标数据及优秀实践参考，推动企业将分散的关怀举措转化为有制度保障、有资源配套、可长期执行的安排。

从企业角度看，更完善的制度安排有助于降低核心员工的流失率，提升在人才市场中的吸引力。优秀企业实践将通过榜单发布和案例研究在行业内传播，为其他企业提供可参照的推进路径。

## 重新理解"好工作"，驱动职场生态升级

"好工作"的标准正在被重新校准。建设家庭友好型职场，关键是打破单一评价逻辑，将工作效率、实际产出、员工身心健康及长期价值创造能力作为核心标尺，通过科学管理让员工以更稳定健康的状态投入工作，实现员工与企业的共同发展。这也是企业践行社会责任的具体体现，企业通过制度建设分担员工的生育、养育、照护和养老压力，为优化生育环境、缓解家庭照护负担、促进心理健康创造条件。

创生基金有关负责人表示，发起本次评选，希望推动社会重新梳理企业发展、员工价值与家庭责任的内在关联。评选将于8月5日至10月9日开放报名，后续将开展调研评估、材料核验及综合评审，最终结果计划于2027年1月正式发布。

![评选日程](/image/评选日程.jpg)

<p style="text-align: center; font-size: small; color: gray;">评选日程</p>
`,
    },
  ],
  zh_TW: [
    {
      id: 1,
      category: 'fertility',
      date: '2025-11-20',
      image: '/image/641.webp',
      title: `鼓勵生育｜攜程創辦人設5億元基金　向在學博士生發放5萬生育津貼`,
      description: `攜程集團聯合創辦人梁建章在港設立「創生基金」，計劃5年內投入5億元，從「經濟補貼、文化倡導、政策研究」三大方向探索低生育率的解決案，其中會向在學博士生發放5萬元的生育津貼。「創生基金」由2026年1月1日起生育子女的在港全日制博士生家庭，可申請5萬元育兒與教育津貼，只要提交子女出生證明、高等院校在學證明及成績單即可申請。其次，基金設立「生育友好」文化藝術創意專項，面向全球徵集能激發生育意願、傳遞家庭溫暖、消除生育焦慮的作品與項目。該專項資助覆蓋個人與機構，資助金額最高為100萬元，每年評選一次，目的在於鼓勵通過影視、文學、藝術裝置等形式宣揚生育為家庭帶來的幸福感。`,
      content: `攜程集團聯合創辦人梁建章在港設立「創生基金」，計劃5年內投入5億元，從「經濟補貼、文化倡導、政策研究」三大方向探索低生育率的解決案，其中會向在學博士生發放5萬元的生育津貼。

「創生基金」由2026年1月1日起生育子女的在港全日制博士生家庭，可申請5萬元育兒與教育津貼，只要提交子女出生證明、高等院校在學證明及成績單即可申請。

其次，基金設立「生育友好」文化藝術創意專項，面向全球徵集能激發生育意願、傳遞家庭溫暖、消除生育焦慮的作品與項目。該專項資助覆蓋個人與機構，資助金額最高為100萬元，每年評選一次，目的在於鼓勵通過影視、文學、藝術裝置等形式宣揚生育為家庭帶來的幸福感。

再者，基金將於明年1月舉辦首屆「全球生育危機論壇」，討論全球人口形勢、低生育率經濟影響、各國政策實踐、女性生育與職業發展平衡等議題。

![创生基金](/image/royn20240228839_1024_1_1200.jpg)
<p style="text-align: center; font-size: small; color: gray;">「創生基金」計劃為在學博士生提供5萬元育兒津貼。（經濟日報圖片）</p>

[來源連結](https://news.hket.com/article/4041111/%E9%BC%93%E5%8B%B5%E7%94%9F%E8%82%B2%EF%BD%9C%E6%94%9C%E7%A8%8B%E5%89%B5%E8%BE%A6%E4%BA%BA%E8%A8%AD5%E5%84%84%E5%85%83%E5%9F%BA%E9%87%91%E3%80%80%E5%90%91%E5%9C%A8%E5%AD%B8%E5%8D%9A%E5%A3%AB%E7%94%9F%E7%99%BC%E6%94%BE5%E8%90%AC%E7%94%9F%E8%82%B2%E6%B4%A5%E8%B2%BC%E3%80%90%E5%85%A7%E9%99%84%E8%A9%B3%E6%83%85%E3%80%91?mtc=40001&srkw=%E6%A2%81%E5%BB%BA%E7%AB%A0)
      `,
    },
    {
      id: 2,
      category: 'fertility',
      date: '2026-02-12',
      image: '/image/20260212-110032.jpg',
      title: '全球生育危機論壇',
      description:
        '世界正面臨人口結構轉折點。全球三分之二人口所在地區的生育率已低於更替水平，威脅經濟穩定、文化延續與可持續發展。這不再是區域性挑戰，而是一場需要緊急集體行動的全球轉型。近日在香港舉行的首屆全球生育危機論壇匯聚聯合國、學界、政府與企業領袖，深入剖析生育下滑根源。討論涵蓋經濟壓力、社會期望轉變，以及AI對家庭生活的衝擊。',
      content: `世界正面臨人口結構轉折點。全球三分之二人口所在地區的生育率已低於更替水平，威脅經濟穩定、文化延續與可持續發展。這不再是區域性挑戰，而是一場需要緊急集體行動的全球轉型。
近日在香港舉行的首屆全球生育危機論壇匯聚聯合國、學界、政府與企業領袖，深入剖析生育下滑根源。討論涵蓋經濟壓力、社會期望轉變，以及AI對家庭生活的衝擊。

聯合國人口司的Vladimira Kantorova強調：「我們必須設計以人為本的介入措施，構建可持續未來，並利用人口趨勢交匯點開創永續未來。」
育媧人口智庫執行長、首席研究員黃文添則緊急呼籲立即恢復更替水平生育率。他提醒與會者：「人們不僅是勞動力，更是消費者、創新基礎、文化語言承載者，以及情感意義的來源。」

#### **5大倡議：行動藍圖**

該論壇核心成果是提出5大倡議框架，為政府、企業、社會提供逆轉生育危機的具體行動指南：  
1. 全球共識：呼籲全球社會認識恢復並維持更替水平生育率是人類文明延續的前提，並推動國際組織建立共享價值觀，將其融入發展框架。  
2. 政府責任：強調低生育率國家政府需切實補償父母撫育子女的貢獻，並建立系統性生育支持政策。  
3. 企業參與：倡導企業擁抱生育友善原則，消除生育相關歧視，減輕員工育兒負擔，開發針對育兒需求的產品與服務，並支持相關公益活動。  
4. 社會支持：推動營造生育友善文化氛圍，凸顯撫育子女的社會價值，並鼓勵家庭成員積極參與育兒責任。  
5. 協同行動：提出應對生育危機需要人類集體力量，構建國際合作平台，共同探索有效且可持續的解決方案。  

#### **科技雙刃劍與文化變遷**

經濟學家梁建章指出，AI正從兩大關鍵面向加劇全球生育危機：AI驅動的娛樂提供即時滿足，與撫育子女的長期承諾競爭，引發虛擬多巴胺是否能取代家庭生活的疑問；AI經濟要求超高技能勞動力，將年輕人推入延長教育與更大財務不穩，導致缺乏時間與金錢建立與維持家庭。在此AI帶來的生育挑戰中，梁建章提出應對深化困境的關鍵論點：「生育子女是對人類延續的有意義貢獻」。  

日本中央大學家庭社會學教授山田昌弘指出文化與經濟壓力：「婚姻已成為奢侈品」，他強調單身率飆升侵蝕勞動力與創新，同時老化人口加重醫療系統負擔。

#### **領導決策時刻**

生育危機正在重塑全球的經濟與社會。全球生育危機論壇提出的5大倡議提供了行動藍圖，現在的關鍵是政府、企業、社區與國際組織的領導力如何將這些原則轉化為實踐。  

人類未來不僅靠創新與經濟，更取決於「孕育新生命」這個最基本的延續選擇。

![创生基金](/image/20260212-110032.jpg)
`,
    },
  ],
  en: [
    {
      id: 1,
      category: 'fertility',
      date: '2025-11-20',
      image: '/image/641.webp',
      title: `Dr James Liang Launches HK$500 Million "Genovation Foundation" to Address Low Fertility`,
      description: `HONG KONG, Nov. 20, 2025 /PRNewswire/ -- On World Children's Day, Dr James Liang, Co-founder of Trip.com Group, announced the establishment of the Genovation Foundation Limited in Hong Kong. Established in his personal capacity, the foundation pledges HK$500 million over five years to address declining fertility through three key avenues: economic subsidies, cultural advocacy, and policy research.`,
      content: `HONG KONG, Nov. 20, 2025 /PRNewswire/ -- On World Children's Day, Dr James Liang, Co-founder of Trip.com Group, announced the establishment of the _Genovation Foundation Limited in Hong Kong_. Established in his personal capacity, the foundation pledges HK$500 million over five years to address declining fertility through three key avenues: economic subsidies, cultural advocacy, and policy research.

The name _Genovation_ combines "Gene" and "Innovation", symbolising both the continuity of life and the pursuit of creative solutions to pressing social challenges. This marks another significant step in Liang's decade-long dedicated research into demographic issues, moving from corporate practice into the realm of public philanthropy.

#### **Supporting Policy Research and Global Dialogue**

Beyond funding policy research, including the _Global Fertility Crisis Forum_ scheduled to launch in January 2026 and held annually thereafter, the foundation has opened applications in two further areas:

  - **Childbearing subsidies for PhD students in Hong Kong**  
  - **Grants for fertility-friendly cultural and artistic projects worldwide**

As a scholar-entrepreneur who has long studied the relationship between demographics and innovation, Liang has repeatedly warned that a shrinking younger population will erode national creativity and long-term economic vitality. He argues that addressing this challenge requires coordinated action across government, business, and society. By piloting initiatives in Hong Kong and focusing on three strategic directions, the foundation aims to create replicable models for wider adoption.

#### **Financial Support for Doctoral Students**

In its first phase, the foundation will pilot a targeted subsidy for doctoral students at higher education institutions in Hong Kong. As a crucial reserve of future research talent, PhD students often face multiple pressures of academic advancement, early career development, and family planning. Despite being in their prime reproductive years, many are forced to delay or abandon parenthood due to research demands, limited income, and the high cost of childcare.

To address this, the foundation will provide a HK$50,000 childcare and education grant to families of full-time PhD students based in Hong Kong whose children are born on or after 1 January 2026. Applications require a birth certificate, proof of enrolment, and academic transcripts. The foundation pledges to complete reviews within 14 working days and disburse funds within five working days. (Further details are available at http://www.genovationfoundation.org/ )

#### **Promoting Fertility-Friendly Cultural Innovation**

Liang recognises that low fertility is not only an economic issue but also shaped by social attitudes and cultural anxieties. To foster a supportive environment, the foundation has established a _Fertility-Friendly Cultural Innovation Project_, inviting global submissions of creative works that inspire childbearing, convey family warmth, and reduce anxiety around parenthood.

The foundation provides grants of up to HK$1 million to individuals and organisations, awarded annually to support creative works — from film and literature to art installations — that celebrate the joy of family life and the positive impact of childbearing."

#### **Global Fertility Crisis Forum**

Low fertility is a shared global challenge requiring international collaboration. A flagship initiative of the foundation will be the _Global Fertility Crisis Forum_, to be held in Hong Kong in January 2026. The forum will examine demographic trends, the economic impact of declining fertility, policy responses, and the balance between women's reproductive choices and career development.

Combining macro-level analysis with personal sharing, the forum is intended to become a regular platform for international dialogue, pooling global expertise to inform policy-making. Liang believes that evidence-based policies and sufficient support can meaningfully raise fertility intentions, and the forum will serve as a hub for such collaborative efforts.

More information about the Global Fertility Crisis Forum can be found at https://globalfertilitycrisis.org/

#### **From Corporate Practice to Public Philanthropy**

The creation of the Genovation Foundation represents another breakthrough in Liang's long-standing commitment to fertility support. Over the past decade, he has authored works such as _The Demographics of Innovation_ and _Population Strategies: How Population Affects Economy and Innovation_, while also implementing childcare-friendly measures at Trip.com Group, including subsidies for employees worldwide and three additional days of parental leave.

He has sought to build public consensus through creative initiatives, such as the philosophical novel and play _After Immortality_ and the interview series _James Liang in Dialogue with Multi-Child Families_. Liang has consistently called for stronger national support, including tax relief, mortgage interest rebates for larger families, and expanded childcare provision.

With government subsidies now in place and public awareness of the fertility crisis growing, Liang's personal investment of HK$500 million reflects his philosophy of "testing solutions through corporate practice, expanding impact through public philanthropy". From supporting employees to engaging society at large, and from financial subsidies to a combined framework of economic, cultural, and policy support, Liang emphasises that safeguarding fertility intentions is safeguarding the future of society and the foundations of innovation. He hopes the _Genovation Foundation_ will act as a seed, encouraging wider participation and transforming childbearing from a "dilemma" into a "choice of hope and happiness".

#### **About the Genovation Foundation**

The _Genovation Foundation_ is a philanthropic organisation dedicated to population development and social innovation. The name _Genovation_ combines "Gene" and "Innovation", symbolising both the continuity of life and the pursuit of creative solutions to pressing social challenges. Established in Hong Kong by Dr James Liang in his personal capacity, the foundation will invest HK$500 million over five years, committed to alleviating poverty through education, promoting fertility, and advocating family virtues.

Official website: http://www.genovationfoundation.org/

media contact: info@genovationfoundation.org

[Source Link](https://finance.yahoo.com/news/dr-james-liang-launches-hk-020000004.html)
      `,
    },
    {
      id: 2,
      category: 'fertility',
      date: '2025-11-20',
      image: '/image/20251120-230632.jpg',
      title: `Baby boom or bust: Trip.com co-founder launches HK$500 million fund to boost birth rates`,
      description: `Trip.com co-founder James Liang says Hong Kong is uniquely placed to help solve China’s looming population crunch. James Liang, co-founder of Chinese online travel giant Trip.com Group, has launched a HK$500 million (US$64.23 million) foundation in Hong Kong to tackle China’s deepening fertility crisis. Citing Hong Kong’s unique advantages as a global hub that facilitates the exchange of international expertise, he said the city was the ideal springboard for tackling China’s mounting demographic pressures.`,
      content: `Trip.com co-founder James Liang says Hong Kong is uniquely placed to help solve China’s looming population crunch.

![创生基金](/image/3f736927-671c-435e-9eef-372ed2515d73_4582b681.webp)
<p style="text-align: center; font-size: small; color: gray;">Trip.com’s James Liang believes that Hong Kong is perfectly placed to help tackle China’s looming demographic crisis. Photo: Xinhua</p>

      
James Liang, co-founder of Chinese online travel giant Trip.com Group, has launched a HK$500 million (US$64.23 million) foundation in Hong Kong to tackle China’s deepening fertility crisis.

Citing Hong Kong’s unique advantages as a global hub that facilitates the exchange of international expertise, he said the city was the ideal springboard for tackling China’s mounting demographic pressures.

“The challenge of low fertility rates faced by Hong Kong society is highly representative, and the foundation’s pilots provide valuable reference for mainland first-tier cities and other similar Asian metropolises,” he told the Post in a written reply.


Established in Liang’s personal capacity and unveiled on World Children’s Day, the Genovation Foundation plans to disburse the funds over five years through three main channels: direct financial support for doctoral students who have children; grants of up to HK$1 million for fertility-friendly cultural and artistic projects; and a global forum that will bring together leading universities to address declining birth rates.

In its pilot phase, the foundation will offer a HK$50,000 childcare and education subsidy to full-time PhD students at Hong Kong universities whose children are born on or after January 1, 2026.

The scheme is intended to plug a gap for young academics who face the competing pressures of career advancement, limited income and high childcare costs at the start of their professional lives.

The foundation said it aims to complete applicant reviews within 14 working days and disburse funds within five working days after approval.

Liang, a scholar-entrepreneur who holds a PhD in economics from Stanford University, has for years been sounding the alarm over China’s demographic challenges.

In Wednesday’s announcement, he warned that a shrinking younger population would undermine the country’s creativity and long-term economic vitality and said that mitigating the decline in birth rates required joint action by the public and private sectors.

China’s population is projected to fall sharply over the rest of the century. Under the United Nations’ baseline scenario, it is expected to decline by roughly a factor of 2.2 to about 633 million by 2100, from around 1.4 billion today.

Hong Kong faces its own acute challenges, with high living and education costs discouraging couples from having children. The city’s total fertility rate stood at 0.772 births per woman in 2021, among the lowest in the world.

![创生基金](/image/1f00c27e-ac1a-4cdb-be65-46ae63ffe736_0f715ac2.avif)
<p style="text-align: center; font-size: small; color: gray;">James Liang, a scholar-entrepreneur who holds a PhD in economics from Stanford University, has for years been sounding the alarm over China’s demographic challenges. Photo: Handout</p>

Alongside the PhD subsidies, the foundation has launched a Fertility-Friendly Cultural Innovation Project, inviting individuals and organisations worldwide to submit creative works that encourage childbearing, convey family warmth and reduce anxiety around parenthood. Annual winners can receive up to HK$1 million in prize money.

Genovation’s flagship initiative will be the Global Fertility Crisis Forum in Hong Kong in January 2026.

The forum will examine demographic trends, the economic impact of low fertility, policy responses and how to balance women’s reproductive choices with their career development.

According to the foundation, its name combines “Gene” and “Innovation” to symbolise both the continuity of life and the search for creative solutions to urgent social problems.

Shanghai-based Trip.com was first listed on the Nasdaq in 2003, followed by a secondary listing on the Hong Kong stock exchange in 2021. In Hong Kong, its shares traded at HK$554 at Thursday’s close, giving it a market capitalisation of about HK$369 billion.

Founded in 1999, the online travel platform has since grown into one of the world’s largest.

In Hong Kong, Trip.com shares were trading at HK$554 on Thursday afternoon, valuing the company at about HK$369 billion.

Liang’s holdings in Trip.com, Tongcheng Travel, and Homeinns Hotel have a combined market value of US$1.2 billion, according to Bloomberg data.

Trip.com, which employs more than 30,000 people worldwide, has itself earmarked 1 billion yuan (US$140.5 million) to subsidise employee births and since 2023 has offered 50,000 yuan to each staff member who has a child.

[Source Link](https://www.scmp.com/business/china-business/article/3333570/baby-boom-or-bust-tripcom-co-founder-launches-hk500-million-fund-boost-birth-rates?share=BTPHKY9HhBAv9UV4buUVgM3Ux362IdlFrRsWb%2F5LujXwCB%2BTl5W%2FFxaPiD%2FZauSmBsLydwIhXGLyX8sBgPHY6GU2i7DbJAlmD1SEzVSrRrW8bCmLIL%2B4mtonEpLGYrV7rVm5Q8XJLbOSI8rXZSSzcA%3D%3D&utm_campaign=social_share)
      `,
    },
    {
      id: 3,
      category: 'fertility',
      date: '2026-02-12',
      image: '/image/20260212-110032.jpg',
      title: 'Global Fertility Crisis Forum',
      description: `HONG KONG -- China's deepening demographic troubles have sent Beijing scrambling to encourage more births. One entrepreneur has taken it upon himself to advocate for solutions to what he calls the country's "biggest-ever challenge." James Liang co-founded the online travel booking operator now known as Trip.com Group and has been its chairman since 2003. But in China, he is better known for his advocacy of higher birth rates. The 56-year-old now spends the bulk of his time researching population issues and has thrown some of his own money behind the effort.`,
      content: `HONG KONG -- China's deepening demographic troubles have sent Beijing scrambling to encourage more births. One entrepreneur has taken it upon himself to advocate for solutions to what he calls the country's "biggest-ever challenge."  

James Liang co-founded the online travel booking operator now known as <a href="https://hk.trip.com/?locale=zh-hk" class="no-icon">Trip.com</a> Group and has been its chairman since 2003. But in China, he is better known for his advocacy of higher birth rates. The 56-year-old now spends the bulk of his time researching population issues and has thrown some of his own money behind the effort.  

The challenge has only grown more acute, as illustrated by China's <a href="https://asia.nikkei.com/economy/demography/china-s-population-decline-deepens-as-birth-rate-hits-new-low" class="no-icon">latest population data</a>, which showed a decline of over 3 million people last year and a record-low number of births. With government efforts to spur the birth rate largely falling flat so far, there may be room for the private sector to play a more important role in addressing China's shrinking and aging population.

<br>
Liang said he came to grips with China's demographic dilemmas while studying for his doctorate at Stanford University more than a decade ago. "When I was looking at the relationship of innovation and demographics, I realized that China's one-child policy was not sustainable and not good for the future of innovation and technology in China," Liang told Nikkei Asia in an interview.  

China announced an end to the one-child rule in 2015.  

"In recent years, I was trying to find a way to get other people to come together to search for a solution," Liang said. "Low fertility is becoming a global problem."  

For Liang, that problem is closely intertwined with economic issues, as China has been mired in a deflationary spiral, with a property sector slowdown and weak consumer demand. He believes this is the place to start.  

"China is not providing generous financial subsidies to parents. Given the current economic situation, China can increase spending or ease monetary policy by printing money to increase demand. That would also help the macroeconomic situation," he said.  

<br>
The Chinese government has previously announced that starting this year, a tax-free lump sum of 3,600 yuan ($516) per year will be granted to eligible parents nationwide for every child up to age 3. The program had already been introduced in some provinces.  

Liang maintains that there is plenty of room for the government to increase subsidies. "It is the first time in history that the government gives a small amount of subsidy, but it's not nearly enough to cover the cost [of raising a child], and it's not very generous relative to other countries."  

According to a 2024 report Liang co-authored, Chinese parents bear some of the highest costs among major countries to raise a child to 18, at 6.5 times gross domestic product per capita. That was compared to 4.26 times in Japan and 2.08 times in Australia, although the figures the report cited were from different time periods.  

In November 2025, Liang set up the Genovation Foundation in Hong Kong in his personal capacity, using 500 million Hong Kong dollars ($64.1 million) of his own money. During its pilot phase, the foundation will offer a HK$50,000-per-child subsidy to full-time doctoral students at Hong Kong universities who have children after Jan. 1, 2026.  

Liang said the foundation has already handed out allowances to the parents of five newborn children during its first week.  

"I'm hoping to do more, but that also depends on my ability," Liang said, adding that the foundation is looking to work with some universities in China to roll out childbearing allowances on the mainland.  

According to a 2024 filing, Liang held 5.3% of ordinary shares in the U.S.- and Hong Kong-listed <a href="https://hk.trip.com/?locale=zh-hk" class="no-icon">Trip.com</a>, or Ctrip as it is known in China.  

Some of Liang's policy suggestions for encouraging people to have kids would put him alongside more liberal academics and intellectuals in the country. In his research, Liang has advocated for equal time off from work for men and women and the introduction of child-care workers from overseas. He has also promoted hybrid working styles and the protection of child-bearing rights of single women.  

At times, he has found himself on the wrong side of the Chinese authorities. In May 2022, Liang's Weibo account was suspended from posting any content after he criticized China's zero-COVID policy and strict lockdowns, arguing that the measures reduced every individual's lifespan by four days.  

<a href="https://hk.trip.com/?locale=zh-hk" class="no-icon">Trip.com</a> itself has found itself in hot water recently, drawing an <a href="https://asia.nikkei.com/business/companies/trip.com-stock-falls-19-as-group-faces-china-antitrust-probe" class="no-icon">antitrust probe</a> by China's State Administration for Market Regulation this month.  

In the interview, Liang said there are quite a few things businesses can do to support young people having more children, "along the lines of allowing young people more flexibility in arranging their career," while the government "can provide an overall framework" of support.  

The private sector in China is responsible for around 80% of urban employment, according to official data from 2024.  

"State-owned companies and the public sector can have similar support measures [for families]. But overall, it's not quite there yet," he said. "We are using more research and communication with the government to have more such measures."  

Liang is not alone in calling for more drastic steps to address China's accelerating demographic decline.  

"Avoiding demographic collapse requires nothing less than a social, economic, cultural, and political paradigm shift," said Yi Fuxian, a senior scientist at the University of Wisconsin-Madison and a long-time opponent of China's one-child policy. "It is necessary to reform the social security and tax systems and strengthen family values to ensure that child-bearing is materially and morally rewarded."  

Yi stressed that China's best option to increase fertility would be to raise its household income share, which would also boost consumption and absorb excess production capacity. But that poses a different dilemma: Increasing households' disposable incomes could also weaken the government's financial resources and power, reshaping China's political landscape. "Such paradigm shifts require the Chinese government to demonstrate sufficient political courage and governance skills and would take at least several decades," he said.  

As Liang sees it, China's rapid technological development poses a new set of challenges that could affect people's willingness to have children. "Artificial Intelligence, in general, is increasing education demand and suppressing wages for entry-level jobs, adding to the insecurity of families. This calls for more urgent support from the government."  

Liang expressed pessimism over technological advancement in an aging society in a science fiction novel published in 2020. The book, the title of which translates to "After Immortality," describes a future in which people live 10,000 years. Despite the staggering life spans, the world feels stagnant, and the solution the novel prescribes is for humans to give up on living forever and instead extend their legacies by having children.  

One of Liang's many gigs is hosting a podcast where he interviews Chinese parents with multiple children about their lives, finances and philosophies for educating their kids. The episodes include policy suggestions from his interviewees on how to encourage people to have bigger families. "A lot of people, especially young people, need to better understand the benefits of having a large family," Liang said of his motivation for producing the show.  

"People have misconceptions that having a large family is too burdensome," he said. "I think there's a lot of benefit, and usually the marginal cost of raising an extra child is not as high as people think."  

![创生基金](/image/20260212-110032.jpg)
`,
    },
  ],
};

/**
 * 根据分类筛选新闻
 * @param {string} category - 'all' | 'fertility' | 'education' | 'poverty'
 * @returns {Array} 筛选后的新闻列表
 */
export const getNewsByCategory = (category, lang = 'zh_TW') => {
  if (category === 'all') {
    return newsDatas[lang];
  }
  return newsDatas[lang].filter((item) => item.category === category);
};

/**
 * 获取最新N条新闻
 * @param {number} count - 新闻数量
 * @returns {Array} 最新新闻列表
 */
export const getLatestNews = (count = 3, lang = 'zh_TW') => {
  return [...newsDatas[lang]]
    .filter(isNewsVisible)
    .sort((a, b) => new Date(b.date) - new Date(a.date))
    .slice(0, count);
};

/**
 * 获取新闻详情
 * @param {number} id - 新闻ID
 * @returns {Object|null} 新闻详情
 */
export const getNewsById = (id, lang = 'zh_TW') => {
  return newsDatas[lang].find((item) => item.id === id) || null;
};

/**
 * 根据标签获取新闻数量
 * @param {string} category - 分类
 * @returns {number} 新闻数量
 */
export const getNewsCountByCategory = (category, lang = 'zh_TW') => {
  if (category === 'all') {
    return newsDatas[lang].length;
  }
  return newsDatas[lang].filter((item) => item.category === category).length;
};
